
  <div class="share-wrap">
    <p class="tips-content">闯关次数已用尽，</p>
    <p class="tips-content">分享可获得1次闯关机会！</p>
    <Button @click="chandleShareClick" class="share-btn">分享</Button>
    <p @click="$emit('close'); showShareTips = false" class="cancel">算了吧</p>
  </div>
  <img v-if="showShareTips" class="share-tips animate__animated animate__fadeInUp" src="@/assets/img/sdws/share-tips.png" alt="">
